import { Dispatch, SetStateAction, useMemo } from 'react';
import { AdditionalSearchType, AssistantSearchType, SearchSubSection, SearchType } from '../../assistantSearchTypes';
import { FilterStateProps } from '../../Assistant';
import { AssistantSearchListItemProps } from './useAssistantSearchResultListMap';

interface SearchResultListProps {
    hasResult: boolean;
    selectedSearchType: AssistantSearchType;
    assistantSearchResultListMap: Record<SearchType | SearchSubSection, AssistantSearchListItemProps[]>;
    setFilterState: Dispatch<SetStateAction<FilterStateProps>>;
    itemsToShow: Record<SearchType, number>;
}

export const useSearchResultList = ({
    hasResult,
    selectedSearchType,
    assistantSearchResultListMap,
    setFilterState,
    itemsToShow,
}: SearchResultListProps) =>
    useMemo(() => {
        let resultList: Array<AssistantSearchListItemProps> = [];
        const availableSearchTypeListOrdered: Record<number, Array<AssistantSearchListItemProps>> = {};

        if (hasResult) {
            if (selectedSearchType === AdditionalSearchType.All) {
                let count = 0;
                Object.keys(assistantSearchResultListMap).forEach((key) => {
                    const list = [
                        ...assistantSearchResultListMap[key as SearchType].slice(0, itemsToShow[key as SearchType]),
                    ];
                    resultList = [...resultList, ...list];
                    if (list.length > 0) {
                        availableSearchTypeListOrdered[count] = list;
                        count++;
                    }
                });
            } else if (assistantSearchResultListMap[selectedSearchType]?.length > 0) {
                resultList = [...resultList, ...assistantSearchResultListMap[selectedSearchType]];
                availableSearchTypeListOrdered[0] = assistantSearchResultListMap[selectedSearchType];
            } else {
                setFilterState((prev) => ({
                    ...prev,
                    selectedSearchType: AdditionalSearchType.All,
                }));
            }
        }
        return {
            searchResultList: resultList,
            availableSearchTypeListOrdered,
        };
    }, [assistantSearchResultListMap, hasResult, itemsToShow, selectedSearchType, setFilterState]);
